export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const UPDATE_MODAL = 'UPDATE_MODAL';
export const UPDATE_WELCOME_MAT = 'UPDATE_WELCOME_MAT';
export const START_WALKTHROUGH = 'START_WALKTHROUGH';
export const INCREMENT_WALKTHROUGH_STEP = 'NEXT_WALKTHROUGH_STEP';
export const CLOSE_WALKTHROUGH = 'CLOSE_WALKTHROUGH';
export const WALKTHROUGH_STEP_SEQUENCE = [
  'einsteinFrequencyRecommendations',
  'emailFrequencyChart',
  'optimizationObjective',
  'preferredFrequencyRange',
  'createDataExtensions'
];
